// extracted by mini-css-extract-plugin
export default {"Icon":"icon_Icon__rT6tF","PrimaryContrast":"icon_PrimaryContrast__lYpck","Pressable":"icon_Pressable__qVnAS"};